module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17899/js/img/valuePropModals/FormConditionalLogic/ValueProp3.svg"